import styled from "styled-components";

export const PromosBodyContentContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? "column" : "row")};
  background: var(--fd-colors-background-surface);
  border-radius: var(--fd-radii-border-radius-020)
    var(--fd-radii-border-radius-020) 0 0;
`;

export const PromosBodyContentWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  background: var(--fd-colors-background-base);
  width: 100%;
`;

export const ContentContainer = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) => isMobile && "flex-direction: column;"}
  display: flex;
  ${({ isMobile }) =>
    isMobile
      ? "gap: calc(var(--fd-space-space-base) + 2px)"
      : "gap: var(--fd-space-space-4)"};
  ${({ isMobile }) =>
    isMobile
      ? "margin: 0 0 calc(var(--fd-space-space-base) + 2px) 0;"
      : "margin: var(--fd-space-space-4)"}
`;

export const LeftColumn = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) => !isMobile && "flex: 2;"}
  display: flex;
  flex-direction: column;
`;

export const RightColumn = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) => !isMobile && "flex: 1;"}
  display: flex;
  flex-direction: column;
  ${({ isMobile }) =>
    isMobile
      ? "gap: calc(var(--fd-space-space-base) + 2px)"
      : "gap: var(--fd-space-space-4)"};
`;

export const FullRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
